import React from 'react';
import { cn } from '@rocco/utils/cn';
import { Button } from '@rocco/components/button';

/**
 * The button component for the `ChatSettings` component.
 * @see {@link ChatSettings}
 */
export function ChatSettingsButton({
    children,
    className,
    ...props
}: React.ComponentProps<typeof Button>) {
    return (
        <Button
            type="button"
            className={cn('px-6 leading-tight', className)}
            color="dark"
            size="larger"
            weight="normal"
            {...props}
        >
            {children}
        </Button>
    );
}
